export default `
  query listUsers($limit: Int, $nextToken: String, $search: String, $sortBy: UserSortInput) {
    listUsers(limit: $limit, nextToken: $nextToken, search: $search, sortBy: $sortBy) {
      items {
        id
        firstname
        lastname
        email
        company
        picture {
          url
          file {
            key
          }
        }
        organisations {
          id
          name
          projects {
            id
            name
            organisation {
              id
              name
            }
            workflows {
              items {
                id
                name
                projectId
                domainEvents {
                  id
                }
              }
              nextToken
            }
          }
        }
        registrationDate
        lastLogin
        loginCounter
        isActive
        referralSource
        usageIntent
        stripeCustomerId
        githubAccounts {
          login
          avatar
        }
        adminNotes {
          id
          type
          content
          subject
          author
          createdAt
          emailSent
          senderEmail
        }
      }
      nextToken
    }
  }
`
